import styled from "styled-components";

import AccountWishlist from "components/customer/AccountWishlist/AccountWishlist/AccountWishlist";

import { remCalc } from "utilities/styles";

export const StyledAccountWishlist = styled(AccountWishlist)`
  padding: ${remCalc(64)} 0 ${remCalc(48)};
`;
